export const LogoSignMobile: {
  name: 'logo_sign_mobile-967086eca237'
} = {
  name: 'logo_sign_mobile-967086eca237'
}
